import { Autocomplete, Chip, TextField } from "@mui/material"
import { TestData, User } from "graphql/types"
import { useStoreActions, useStoreState } from "hooks/storeHooks"
import { useEffect } from "react"
import { emptyPerson } from "store/store"
import { useLocalStorage } from "utils/useLocalStorage"

type AddHelperBoxProps = {
  data: TestData
  setData: (data: TestData) => void
}

export const AddHelperBox = (props: AddHelperBoxProps) => {
  const { data, setData } = props
  const users = useStoreState((state) => state.users)
  const [currentUser] = useLocalStorage<User>("user", emptyPerson)

  const { fetchUsers } = useStoreActions((actions) => actions)

  useEffect(() => {
    const loadUsers = async () => {
      try {
        await fetchUsers({ fresh: false })
      } catch (err) {
        console.error("Error loading users:", err)
      }
    }
    loadUsers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Autocomplete
      sx={{ mt: 1 }}
      size="small"
      multiple
      id="tags-outlined"
      options={users.filter((employee) => employee.id !== currentUser?.id)}
      getOptionLabel={(option) => option?.displayName ?? ""}
      filterSelectedOptions
      value={data.helper}
      renderInput={(params) => <TextField {...params} label="Hilfskraft" />}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          {option.displayName}
        </li>
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={index}
            label={`${option.displayName}`}
            size="small"
          />
        ))
      }
      onChange={(_, value) => {
        if (value) {
          setData({ ...data, helper: value })
        }
      }}
    />
  )
}
